import React from 'react'

import ApiMessageStyles from "./ApiMessage.module.css"

import blueStar from "../../images/attention.svg"
import redWarning from "../../images/caution.svg"

export default function ApiMessage({ children, type }) {
    // console.log("type: ", type)
    // console.log("children: ", children)
    
    // if(Array.isArray(children)){
    //     children.forEach(element => {
    //         console.log("type of children: ", typeof(element))
    //     })        
    // }


    return(       
        <div className={ApiMessageStyles.container + ' ' + ApiMessageStyles[`${type}`]}>
            {
                type === "note" &&
                    <div>
                        <img src={blueStar} alt='note' />
                    </div>                    
            }  
            {
                type === "warning" &&
                    <div>
                        <img src={redWarning} alt='warning' />
                    </div>                    
            }                           
            <div>
                { type === "note" && <span className={ApiMessageStyles.colored}>Note: </span>}
                { type === "warning" && <span className={ApiMessageStyles.colored}>Caution: </span>}
                {/* {children} */}
                {
                    typeof(children) === 'string'
                    ? <div className={ApiMessageStyles.message} dangerouslySetInnerHTML={ {__html: children} }  />
                    : children
                }
            </div>
        </div>
    )
}